import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import gql from 'graphql-tag'
import { useLazyQuery } from '@apollo/react-hooks'
import { get } from 'lodash'
import { dateFormatter } from '../../utils/dateFunctions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons'
import { Link, useParams} from 'react-router-dom'
import { itemType } from '../../types'
import {shouldFileDisable} from '../../utils/fileSizeFunctions'

const GET_DOWNLOAD_URL = gql`
  query GetDownloadUrl($itemId: ID!, $name: String, $id: ID) {
    file(itemId: $itemId, name: $name, id: $id) {
      downloadUri
    }
  }
`

export default function FileDetails({ item }) {
  const { fileIdentifier } = useParams()

  const fetchFile = (item) => {
    const fileConnection = get(item, 'fileConnection')
    if (!fileConnection.files) return {}
    let  foundFile= fileConnection.files.find( file => file.id === fileIdentifier || file.name === fileIdentifier || file.cuid === fileIdentifier )
    //Set key value for json
    if (foundFile && !foundFile.key) foundFile.key = item.id+'/'+foundFile.name
    return foundFile
  }

  const fetchVariables = (item) => {
    const file = fetchFile(item)

    if (!item || !file) return {}

    return {
      id: file.id,
      name: file.name,
      itemId: item.id
    }
  }

  const [ loadDownloadUrl, { called, loading, data } ] = useLazyQuery(
    GET_DOWNLOAD_URL,
    {
      variables: fetchVariables(item),
      fetchPolicy: 'no-cache'
    },
  )

  const fileInfo = (file) => {

    return (
      <div>
        Uploaded by <i>{file.uploadedBy}</i> on <i>{dateFormatter(file.dateUploaded)}</i>
        <br />
        {file.id}
        <br />
        <pre>
          {file ? JSON.stringify(file, null, 2): ''}
        </pre>
      </div>
    )
  }

  const file = fetchFile(item)
  const isScanning = shouldFileDisable(file)
  return (
    <>
      <h2 className="sb-section-header"><Link to={`/item/${item.id}/files`}>Files</Link> &rarr; {file.name}</h2>
      { called ? '' : <Button variant="link" disabled={isScanning?true:false} onClick={loadDownloadUrl}><FontAwesomeIcon icon={faFileDownload} fixedWidth/> Create Download Link</Button> }
      { loading ? <p>Loading...</p> : ''}
      { data && data.file ? <a href={data.file.downloadUri}>Download</a> : ''}
      { item ? fileInfo(file) : '' }
    </>
  )
}

FileDetails.propTypes = {
  match: PropTypes.any,
  item: itemType
}